import { Injectable } from '@angular/core';
import { Project } from '../models/project';

type EditableCells = Pick<Project, 'hours' | 'notes' | 'review' | 'id' | 'ui'>;

@Injectable({ providedIn: 'root' })
export class TimesheetShadowProjectsService {
  create(projects: Project[]): Project[] {
    return projects.map((project) => this.emptyShadow(project));
  }

  hasChanges(projects: Project[], shadowProjects: Project[], weekDays: string[]): boolean {
    const shadowByVirtualId = this.indexByVirtualId(shadowProjects);

    return projects.some((project) => {
      const shadow = shadowByVirtualId.get(project.ui.virtualId);
      return !shadow || weekDays.some((day) => this.cellChanged(project, shadow, day));
    });
  }

  syncCell(project: Project, shadowProjects: Project[], day: string): void {
    const shadow = shadowProjects.find((p) => p.ui.virtualId === project.ui.virtualId);
    if (!shadow) return;

    shadow.hours[day] = project.hours[day];
    shadow.notes[day] = project.notes[day];
  }

  private emptyShadow(project: Project): Project {
    return {
      hours: {},
      notes: {},
      review: {},
      id: project.id,
      ui: project.ui,
    } as Project;
  }

  private indexByVirtualId(projects: EditableCells[]): Map<string, EditableCells> {
    return projects.reduce((index, project) => {
      index.set(project.ui.virtualId, project);
      return index;
    }, new Map<string, EditableCells>());
  }

  private cellChanged(project: EditableCells, shadow: EditableCells, day: string): boolean {
    return project.hours[day] !== shadow.hours[day] || project.notes[day] !== shadow.notes[day];
  }
}
